import React from 'react';
import BackArrow from '../../../assets/icons/left-ar.svg';
import NextArrow from '../../../assets/icons/right-ar.svg';
import Icon from '../icon';

function Pagination({ pages, onClick, currentPage = 1, classes }) {

  currentPage = Boolean(currentPage) ? currentPage : 1;

  return (
    <>
      {pages.length > 1 &&
        <ul className={`pagination-ue ${classes ? classes : ''}`}>
          {Number(currentPage) !== 1 &&
            <li onClick={onClick.bind(null, Number(currentPage) - 1)}>
              <Icon icon={BackArrow} classes="xxs" />
            </li>
          }
          {pages.map((p, i) => {
            return <li key={i} onClick={onClick.bind(null, i + 1)} className={`${Number(currentPage) === i + 1 ? 'active' : ''}`} >{i + 1}</li>
          })}
          {Number(currentPage) !== pages.length &&
            <li onClick={onClick.bind(null, Number(currentPage) + 1)}>
              <Icon icon={NextArrow} classes="xxs" />
            </li>
          }
        </ul>
      }

    </>
  )
}

export default Pagination;